// import React from "react";
// import { Routes, Route, Navigate } from "react-router-dom";

// import AdminLayout from "layouts/admin";
// import AuthLayout from "layouts/auth";

// const App = () => {
//   return (
//     <Routes>
//       <Route path="auth/*" element={<AuthLayout />} />
//       <Route path="/*" element={<AdminLayout />} />
//       {/* <Route path="/" element={<Navigate to="/admin" replace />} /> */}
//     </Routes>
//   );
// };

// export default App;

import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { useDispatch, useSelector } from "react-redux";
import Auth from "store/slice/auth";

const App = () => {
  const auth = Auth();
  const dispatch = useDispatch();
  const location = useLocation();

  const socialStorageString = localStorage.getItem("social-storage");
  const socialStorage = JSON.parse(socialStorageString);

  useEffect(() => {
    if (socialStorage && socialStorage.token) {
      auth.setToken(socialStorage.token);
    }
    if (socialStorage && socialStorage.isLoggedIn) {
      dispatch(
        auth.setLoggedIn(JSON.parse(socialStorage && socialStorage.isLoggedIn))
      );
    }
    // eslint-disable-next-line
  }, []);

  const { isLoggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    const storedIsLoggedIn = socialStorage && socialStorage.isLoggedIn;
    dispatch(auth.setLoggedIn(storedIsLoggedIn));
  }, [isLoggedIn]);

  const isLoggedin = isLoggedIn || (socialStorage && socialStorage.isLoggedIn);

  return (
    <Routes>
      {/* <Route path="auth/*" element={<AuthLayout />} />
      <Route path="/*" element={<AdminLayout />} /> */}
      <Route
        path="auth/*"
        element={
          isLoggedin ? (
            <Navigate to="/users" replace state={{ from: location }} />
          ) : (
            <AuthLayout />
          )
        }
      />
      <Route
        path="/*"
        element={
          isLoggedin ? (
            <AdminLayout />
          ) : (
            <Navigate to="/auth/sign-in" replace state={{ from: location }} />
          )
        }
      />
      {/* <Route path="/" element={<Navigate to="/admin" replace />} /> */}
    </Routes>
  );
};

export default App;
